import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AttachmentPopUp from "./AttachmentPopUp";
import AttachmentDetailPopUpComponent from "./AttachmentDetailPopUpComponent";
import moment from "moment";
import { env } from "../../env";
import axios from "axios";

const AttachmentComponent = ({isActive, customerId, attachmentList, updateAttachmentList }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [showDetailPopUp, setShowDetailPopUp] = useState(false);
    const [currentAttachment, setCurrentAttachment] = useState({});
    const [categoryList, setCategoryList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');

            await getAttachmentCategoryListApi(baseUrl, token);
        };
        fetchData();
    }, []);

    const getAttachmentCategoryListApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/CustomerDetails/GetAttachmentCategoryList`,{ headers })
        .then((response) => {
            setCategoryList(response.data);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleModalCloseDataFromChild = () => {
        setShowDetailPopUp(false);
    };
    const handleAttachmentPopUpDataFromChild = (data) => {
        if(data === 'updated') {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');
            const headers = {
                "Accept" : "Application/json",
                "Content-Type" : "Application/json",
                "Authorization" : `Bearer ${token}`
            };

            axios.get(baseUrl + `/api/OfflineSync/GetCustomerAttachments?customerid=${customerId}`, { headers })
                .then((response) => {
                    updateAttachmentList(response.data);
                    setShowModal(false);
                })
                .catch((error) => {
                    console.error(error);
                    if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("userInfo");
                        window.location.reload();
                    }
                });
        } else {
            setShowModal(false);
        }
    };
    const handleShowDetailPopUp = (e, data) => {
        setCurrentAttachment(data);
        setShowDetailPopUp(!showDetailPopUp);
    };
   
    return (
        <div className="relative">
            <div className="sm:grid lg:grid-cols-2 xl:grid-cols-3 gap-2 sm:gap-4 bg-white sm:bg-transparent rounded-xl sm:rounded-none p-2 sm:p-0">
                <div onClick={(e) => (isActive ? setShowModal(!showModal) : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed") + " rounded-xl border-gray-normal border border-dashed hidden sm:flex flex-col justify-center items-center min-h-20"}>
                    <div className="flex items-center space-x-2">
                        <img className="w-8 h-8" src="../../assets/icons/profile/plus.svg" alt="plus" />
                        <div className="font-medium capitalize">{ t("add new attachments")}</div>
                    </div>
                </div>
                {attachmentList.length > 0 ? (
                    attachmentList.map((attachment, index) => {
                        return attachment.imageName ? (
                            <div key={`attachment-${index}`}>
                                <div className="sm:rounded-xl sm:bg-white flex justify-between items-center sm:p-4 w-full cursor-pointer" onClick={(e) => handleShowDetailPopUp(e, attachment)}>
                                    <div className="flex space-x-2 items-center w-full">
                                        <div className="bg-blue-light rounded-xl p-2">
                                            <img className="w-6 h-6 sm:w-8 sm:h-8" src="../../assets/icons/profile/file.svg" alt="file" />
                                        </div>
                                        <div className="flex justify-between items-center w-full">
                                            <div>
                                                <h1 className="font-semibold text-xs sm:text-base break-all capitalize">{attachment.imageName}</h1>
                                                <div className="first-letter:capitalize text-[10px] sm:text-sm">{ t('last updated on')} {attachment.createdOn ? moment(attachment.createdOn, "DD/MM/YYYY").format('ll') : '--'}</div>
                                            </div>
                                            <div className="cursor-pointer px-1 pb-1">
                                                <img src="../../assets/icons/profile/arrow-right.svg" alt="arrow-right" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {attachmentList.length !== index + 1 && (<div className="my-2 border-t border-dashed border-background-normal block sm:hidden"></div>)}
                            </div>
                        ) : null;
                    })
                ) : (
                    <div className="p-4 text-center font-bold text-xs sm:text-xl rounded-lg capitalize bg-white block sm:hidden">
                        {t('no data available')}
                    </div>
                )}
            </div>
            {showModal
            ? <AttachmentPopUp customerId={customerId} categoryList={categoryList} sendAttachmentPopUpDataFromChild={handleAttachmentPopUpDataFromChild} />
            : null}
            {/* modal */}
            {showDetailPopUp &&
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <AttachmentDetailPopUpComponent sendModalCloseDataFromChild={handleModalCloseDataFromChild} attachmentData={currentAttachment} />
                        </div>
                    </div>
                </div>
            }
            <div className="fixed bottom-2 sm:hidden w-screen left-0 px-4">
                <div onClick={(e) => (isActive ? setShowModal(!showModal) : null)} className={(isActive ? "cursor-pointer" : "cursor-not-allowed")}>
                    <div className="rounded-lg  p-2 text-white bg-blue-normal font-medium text-center capitalize">
                        + { t("add new attachments")}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AttachmentComponent;